import { createAction } from "@reduxjs/toolkit";
import { DatasetCleanupType } from "../../@shared/Models/Models";

export const openSchemaDataModalAction = createAction<string>('openSchemaDataModalAction');
export const closeModelDataModalAction = createAction('closeModelDataModalAction');
export const saveModelDataModalAction = createAction('saveModelDataModalAction');
export const removeModelDataAction = createAction<string>('removeModelDataAction');
export const cleanModelDataModalAction = createAction<{ schemaId: string, cleanType: DatasetCleanupType }>('cleanModelDataModalAction');